/* ═══════════════════════════════════════════════════════════════════
   LA CHIOCCIOLA · LUMÉ — il negozio su Shopify
   Nato da chiara.js della landing (la-chiocciola.pages.dev): firma, scene,
   menu, video, tracciamento e stampa sono gli stessi, righe identiche.
   Cambia il negozio: prodotti, carrello e cassa sono quelli veri di Shopify.
   Zero librerie, zero CDN. Un solo listener di scroll dentro un solo rAF.
   ═══════════════════════════════════════════════════════════════════ */
'use strict';

/* La configurazione la scrive il Liquid (layout/lume.liquid · #lume-config). */
const CONFIG = (() => {
  try { return JSON.parse(document.getElementById('lume-config').textContent); }
  catch (e) { return { whatsapp: '', rotte: { cart: '/cart', add: '/cart/add', change: '/cart/change', cassa: '/checkout' } }; }
})();

/* due aiuti della landing, identici: limite di un valore e «meno animazioni» */
const stretta = (v, a, b) => Math.max(a, Math.min(b, v));
const fermo = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ═════════════════════════════════════════════════════════════════
   1 · 🐌 LA FIRMA — LA SCIA CHE RESTA

   Il marchio del cliente cammina lungo il margine della pagina mentre
   si scorre, e lascia dietro di sé la sua scia. La scia non si cancella:
   arrivati in fondo, si vede il percorso intero — dal campo alla tavola.
   Un punto sulla scia per ogni tappa: si accende quando la si raggiunge.
   ═════════════════════════════════════════════════════════════════ */
const ALTEZZA_VB = 1000;   // altezza del sistema di coordinate dell'SVG
const LARGHEZZA_VB = 46;

function tracciaSentiero() {
  // una sinusoide smorzata: scende dritta ma ondeggia, come cammina una lumaca
  const punti = [];
  const passi = 120;
  for (let i = 0; i <= passi; i++) {
    const t = i / passi;
    const y = t * ALTEZZA_VB;
    const ampiezza = 11 * (0.55 + 0.45 * Math.sin(t * Math.PI));   // stretta agli estremi
    const x = LARGHEZZA_VB / 2 + Math.sin(t * Math.PI * 5.5) * ampiezza;
    punti.push([x, y]);
  }
  // curva morbida che passa per i punti
  let d = 'M' + punti[0][0].toFixed(2) + ' ' + punti[0][1].toFixed(2);
  for (let i = 1; i < punti.length; i++) {
    const [x0, y0] = punti[i - 1];
    const [x1, y1] = punti[i];
    const my = (y0 + y1) / 2;
    d += 'C' + x0.toFixed(2) + ' ' + my.toFixed(2) + ',' +
               x1.toFixed(2) + ' ' + my.toFixed(2) + ',' +
               x1.toFixed(2) + ' ' + y1.toFixed(2);
  }
  return d;
}

function avviaScia() {
  const scia = document.querySelector('#scia');
  if (!scia) return null;

  const traccia = scia.querySelector('.scia__traccia');
  const filo    = scia.querySelector('.scia__filo');
  const bestia  = scia.querySelector('.scia__bestia');
  const gruppoTappe = scia.querySelector('.scia__tappe');

  const d = tracciaSentiero();
  traccia.setAttribute('d', d);
  filo.setAttribute('d', d);

  const lunghezza = traccia.getTotalLength();
  [traccia, filo].forEach((p) => {
    p.style.strokeDasharray = lunghezza;
    p.style.strokeDashoffset = lunghezza;
  });

  // una tappa per ogni sezione con un id: si accende quando la si supera
  const sezioni = [...document.querySelectorAll('main section[id]')];
  const tappe = sezioni.map((sez, i) => {
    const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('class', 'scia__tappa');
    const quota = (i + 1) / (sezioni.length + 1);
    const p = traccia.getPointAtLength(lunghezza * quota);
    c.setAttribute('cx', p.x.toFixed(2));
    c.setAttribute('cy', p.y.toFixed(2));
    gruppoTappe.appendChild(c);
    return { el: c, quota, sez };
  });

  if (fermo()) {
    // chi ha chiesto meno movimento vede il sentiero già percorso: ha senso da solo
    [traccia, filo].forEach((p) => { p.style.strokeDashoffset = 0; });
    tappe.forEach((t) => t.el.dataset.fatta = '1');
    scia.dataset.viva = '1';
    return null;
  }

  scia.dataset.viva = '1';

  return function rendi(avanzo) {
    const scoperto = lunghezza * avanzo;
    traccia.style.strokeDashoffset = (lunghezza - scoperto).toFixed(1);
    filo.style.strokeDashoffset = (lunghezza - scoperto).toFixed(1);

    // la bestia sta in punta alla scia
    const p = traccia.getPointAtLength(stretta(scoperto, 0, lunghezza));
    const riquadro = scia.getBoundingClientRect();
    const px = p.x * (riquadro.width / LARGHEZZA_VB);
    const py = p.y * (riquadro.height / ALTEZZA_VB);
    // di quanto è inclinata la scia qui: la lumaca guarda dove sta andando
    const q = traccia.getPointAtLength(stretta(scoperto + 8, 0, lunghezza));
    const inclina = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI - 90;
    bestia.style.transform =
      'translate3d(' + (px - 15).toFixed(1) + 'px,' + (py - 12).toFixed(1) + 'px,0) rotate(' + inclina.toFixed(1) + 'deg)';

    for (const t of tappe) t.el.dataset.fatta = avanzo >= t.quota ? '1' : '0';
  };
}

/* ═════════════════════════════════════════════════════════════════
   2 · LO SCORRIMENTO — un solo listener, un solo requestAnimationFrame
   ═════════════════════════════════════════════════════════════════ */
/* ─────────────────────────────────────────────────────────────────
   LA REGIA — chi vuole muoversi con lo scroll si iscrive qui.
   Un solo listener e un solo requestAnimationFrame per tutto il sito:
   è il motivo per cui la pagina resta fluida anche con molte scene.
   Ogni scena riceve q = quanto è avanzata, da 0 (sta per entrare)
   a 1 (è appena uscita), e scrive SOLO transform, opacity o variabili.
   ───────────────────────────────────────────────────────────────── */
const REGIA = [];
function inScena(el, disegna, opzioni) {
  if (!el) return;
  const o = opzioni || {};
  REGIA.push({ el, disegna, dentro: o.dentro || 0, fuori: o.fuori || 0, ultimo: -1 });
}

function avviaScorrimento(rendiScia) {
  const testa = document.querySelector('#testa');
  const scia = document.querySelector('#scia');
  let atteso = 0, corrente = 0, inCoda = false;

  function misura() {
    const alto = document.documentElement.scrollHeight - innerHeight;
    atteso = alto > 0 ? stretta(scrollY / alto, 0, 1) : 0;
    if (testa) testa.dataset.fissa = scrollY > 40 ? '1' : '0';
    if (!inCoda) { inCoda = true; requestAnimationFrame(passo); }
  }

  /* le scene si misurano sulla posizione vera dell'elemento nello schermo */
  function recita() {
    const h = innerHeight;
    for (const s of REGIA) {
      const r = s.el.getBoundingClientRect();
      const corsa = r.height + h - s.dentro - s.fuori;
      if (corsa <= 0) continue;
      const q = stretta((h - s.dentro - r.top) / corsa, 0, 1);
      if (Math.abs(q - s.ultimo) < 0.0015) continue;   // niente lavoro inutile
      s.ultimo = q;
      s.disegna(q, r);
    }
  }

  function passo() {
    inCoda = false;
    corrente += (atteso - corrente) * 0.14;          // inseguimento morbido
    if (Math.abs(atteso - corrente) < 0.0008) corrente = atteso;
    if (rendiScia) rendiScia(corrente);
    if (scia) scia.style.setProperty('--avanzo', corrente.toFixed(4));
    recita();
    if (corrente !== atteso && !inCoda) { inCoda = true; requestAnimationFrame(passo); }
  }

  addEventListener('scroll', misura, { passive: true });
  addEventListener('resize', () => { REGIA.forEach((s) => { s.ultimo = -1; }); misura(); }, { passive: true });
  misura();
  requestAnimationFrame(recita);   // prima posa, prima ancora di scorrere
}


/* ═════════════════════════════════════════════════════════════════
   LE SCENE — una trovata per sezione, tutte appese alla stessa regia.
   Regola: si scrivono solo transform, opacity e variabili CSS.
   Chi ha chiesto meno movimento le salta tutte e vede la forma finale.
   ═════════════════════════════════════════════════════════════════ */

/* 1 · L'APERTURA — il video si allarga e il titolo sale.
   Entrando, la fotografia è una fessura orizzontale; scorrendo si apre
   a tutto schermo, come una persiana che si alza sul campo. */
function scenaApertura() {
  const ap = document.querySelector('.apertura');
  if (!ap) return;
  const sfondo = ap.querySelector('.apertura__sfondo');
  const dentro = ap.querySelector('.apertura__dentro');
  if (!sfondo) return;

  sfondo.style.willChange = 'transform';
  /* L'apertura è già a schermo al caricamento, quindi NON si misura come le altre
     scene (che entrano dal basso): qui l'avanzamento è quanto se n'è andata via
     dall'alto — 0 a pagina ferma, 1 quando è appena uscita.

     🔴 Qui c'era una «persiana»: un clip-path che al caricamento tagliava il video
     del 18% sopra e sotto e si apriva scorrendo. Il risultato era che chi arrivava
     sul sito vedeva il video mozzato. Tolta: il video riempie la sezione da subito,
     e del movimento resta solo il respiro lento dello sfondo. */
  inScena(ap, (_q, r) => {
    const via = stretta(-r.top / Math.max(1, r.height), 0, 1);
    const q = via;
    sfondo.style.transform = `scale(${(1 + q * 0.04).toFixed(4)})`;   // si allontana appena, scorrendo
    if (dentro) {
      const su = q * 70;                             // il testo scivola più lento dello sfondo
      dentro.style.transform = `translate3d(0, ${(-su).toFixed(1)}px, 0)`;
      // svanisce presto: non deve mai finire sotto le voci dell'intestazione
      dentro.style.opacity = (1 - stretta((q - 0.42) * 2.6, 0, 1)).toFixed(3);
    }
  });
}

/* 2 · I QUATTRO MINUTI — il tempo che scorre mentre scendi.
   È la promessa del sito: la si guarda avverarsi invece di leggerla. */
/* Il quadrante non conta più i minuti di cottura: conta la percentuale di
   chiocciole dichiarata sull'etichetta delle trifolate (52%). Stessa animazione,
   stesso arco che si chiude, ma il numero adesso dice qualcosa sul prodotto. */
function scenaTempo() {
  const sez = document.querySelector('#promessa');
  if (!sez) return;
  const cifra = sez.querySelector('.tempo__cifra');
  const arco = sez.querySelector('.tempo__arco');
  const passi = [...sez.querySelectorAll('.tempo__passo')];
  if (!cifra || !arco) return;

  const giro = arco.getTotalLength ? arco.getTotalLength() : 440;
  arco.style.strokeDasharray = giro;

  inScena(sez, (q) => {
    const a = stretta((q - 0.18) * 1.9, 0, 1);       // parte quando la sezione è entrata
    cifra.textContent = Math.round(a * 52);
    arco.style.strokeDashoffset = (giro * (1 - a)).toFixed(1);
    passi.forEach((p, i) => {
      p.dataset.acceso = a > (i + 0.55) / passi.length ? '1' : '0';
    });
  }, { dentro: innerHeight * 0.25 });
}

/* 3 · UNA STAGIONE INTERA — la sezione resta ferma e il tempo passa.
   Quattro tappe dell'allevamento che si danno il cambio mentre si scorre:
   è «un anno» raccontato con il gesto di scendere. */
function scenaStagioni() {
  const sez = document.querySelector('#stagioni');
  if (!sez) return;
  const tappe = [...sez.querySelectorAll('.stagione')];
  const barra = sez.querySelector('.stagioni__barra span');
  if (!tappe.length) return;

  /* le tappe si distribuiscono sul tratto in cui la sezione è DAVVERO ferma
     (lo sticky), non su tutto il passaggio: altrimenti la prima sfila via subito */
  inScena(sez, (_q, r) => {
    const corsa = r.height - innerHeight;
    const a = corsa > 0 ? stretta(-r.top / corsa, 0, 1) : 0;
    // un margine in coda, così l'ultima tappa resta in vista prima di uscire
    const quale = Math.min(tappe.length - 1, Math.floor(stretta(a / 0.92, 0, 0.999) * tappe.length));
    tappe.forEach((t, i) => { t.dataset.viva = i === quale ? '1' : '0'; });
    if (barra) barra.style.transform = `scaleX(${a.toFixed(3)})`;
    sez.dataset.tappa = quale;
  });
}

/* 4 · I NUMERI CHE SI CONTANO — le cifre dell'etichetta salgono
   quando entrano in vista, una volta sola. */
function scenaNumeri() {
  const cifre = [...document.querySelectorAll('[data-conta]')];
  if (!cifre.length) return;
  if (fermo() || !('IntersectionObserver' in window)) {
    cifre.forEach((c) => { c.textContent = c.dataset.conta.replace('.', ','); });
    return;
  }
  const occhio = new IntersectionObserver((voci) => {
    voci.forEach((v) => {
      if (!v.isIntersecting) return;
      occhio.unobserve(v.target);
      const meta = parseFloat(v.target.dataset.conta);
      const decimali = (v.target.dataset.conta.split('.')[1] || '').length;
      const durata = 900;
      const inizio = performance.now();
      const salta = () => {
        const t = stretta((performance.now() - inizio) / durata, 0, 1);
        const e = 1 - Math.pow(1 - t, 3);
        v.target.textContent = (meta * e).toFixed(decimali).replace('.', ',');
        if (t < 1) requestAnimationFrame(salta);
      };
      requestAnimationFrame(salta);
    });
  }, { threshold: 0.6 });
  cifre.forEach((c) => { c.textContent = '0'; occhio.observe(c); });
}

/* 5 · IL VIAGGIO DEL PACCO — la linea della spedizione si completa
   mentre si legge, e le tappe si accendono al suo passaggio. */
function scenaSpedizione() {
  const sez = document.querySelector('#spedizione');
  if (!sez) return;
  const filo = sez.querySelector('.viaggio__filo');
  const soste = [...sez.querySelectorAll('.viaggio__sosta')];
  if (!filo) return;
  const lung = filo.getTotalLength ? filo.getTotalLength() : 300;
  filo.style.strokeDasharray = lung;
  filo.style.strokeDashoffset = lung;

  inScena(sez, (q) => {
    const a = stretta((q - 0.2) * 2, 0, 1);
    filo.style.strokeDashoffset = (lung * (1 - a)).toFixed(1);
    soste.forEach((s, i) => { s.dataset.toccata = a > (i + 0.4) / soste.length ? '1' : '0'; });
  }, { dentro: innerHeight * 0.2 });
}

/* 6 · LE FOTO CHE RESPIRANO — dentro la loro cornice la fotografia
   si muove appena in controtempo: dà profondità senza far scattare nulla. */
function scenaParallasse() {
  const cornici = [...document.querySelectorAll('[data-parallasse]')];
  if (!cornici.length || fermo()) return;
  cornici.forEach((c) => {
    const img = c.querySelector('img, picture img, video');
    if (!img) return;
    img.style.willChange = 'transform';
    img.style.transform = 'scale(1.14)';
    inScena(c, (q) => {
      const spostamento = (q - 0.5) * 46;            // ±23 px
      img.style.transform = `translate3d(0, ${spostamento.toFixed(1)}px, 0) scale(1.14)`;
    });
  });
}

function avviaComparse() {
  const pezzi = document.querySelectorAll('.entra');
  if (!pezzi.length) return;
  if (fermo() || !('IntersectionObserver' in window)) {
    pezzi.forEach((p) => p.classList.add('dentro-schermo'));
    return;
  }
  const occhio = new IntersectionObserver((voci) => {
    voci.forEach((v) => {
      if (v.isIntersecting) { v.target.classList.add('dentro-schermo'); occhio.unobserve(v.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  pezzi.forEach((p) => occhio.observe(p));
}

/* ═════════════════════════════════════════════════════════════════
   4 · IL NEGOZIO — su Shopify
   Prodotti, prezzi e disponibilità arrivano dal Liquid (script JSON dentro
   ogni scheda): qui non c'è nessun elenco di prodotti da tenere allineato.
   ═════════════════════════════════════════════════════════════════ */
function euro(centesimi) {
  const n = Number(centesimi) / 100;
  if (!isFinite(n)) return '';
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);
}
function leggiJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
function foto(url, w) { if (!url) return ''; return url + (url.includes('?') ? '&' : '?') + 'width=' + w; }

/* ═════════════════════════════════════════════════════════════════
   4b · IL SELETTORE DI FORMATO — uno solo, per la scheda e per la pagina
   Con più formati non se ne preseleziona nessuno (si legge «a partire da»);
   scelto il formato, il prezzo diventa secco e il pulsante si accende.
   ═════════════════════════════════════════════════════════════════ */
function collegaVarianti(cont) {
  const dati = cont.querySelector('script[data-varianti]');
  const varianti = dati ? leggiJSON(dati) : null;
  const btn = cont.querySelector('[data-compra]');
  if (!varianti || !varianti.length || !btn) return;

  const piuVarianti = varianti.length > 1;
  let scelta = piuVarianti ? null : varianti[0];
  const img = cont.querySelector('.prod__img');
  const num = cont.querySelector('.prod__prezzo__n');
  const dap = cont.querySelector('.prod__dapartire');
  const nome = ((cont.querySelector('.prod__nome, .pdp__nome') || {}).textContent || '').trim();
  const bottoni = [...cont.querySelectorAll('.variante')];

  const pulsante = () => {
    if (!scelta) { btn.textContent = 'Scegli il formato'; btn.disabled = true; return; }
    btn.disabled = !scelta.disponibile;
    btn.textContent = scelta.disponibile ? 'Aggiungi al carrello' : 'Esaurito';
  };
  pulsante();
  btn.addEventListener('click', () => {
    if (scelta && scelta.disponibile) carrello.aggiungi([{ id: scelta.id, quantity: 1 }], btn);
  });

  const scegli = (b) => {
    const v = varianti.find((x) => String(x.id) === b.dataset.variante);
    if (!v) return;
    scelta = v;
    bottoni.forEach((x) => x.setAttribute('aria-checked', String(x === b)));
    if (num) num.textContent = euro(v.prezzo);
    if (dap) dap.hidden = true;
    if (img && v.foto) { img.removeAttribute('srcset'); img.src = v.foto; }
    if (img) img.alt = `${nome} — ${v.formato}`;
    pulsante();
  };
  bottoni.forEach((b) => b.addEventListener('click', () => scegli(b)));

  if (piuVarianti) {
    bottoni.forEach((b, i) => b.addEventListener('keydown', (e) => {
      const passo = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
                  : e.key === 'ArrowLeft'  || e.key === 'ArrowUp'   ? -1 : 0;
      if (!passo) return;
      e.preventDefault();
      const n = bottoni[(i + passo + bottoni.length) % bottoni.length];
      scegli(n); n.focus();
    }));
  }
}

/* ═════════════════════════════════════════════════════════════════
   5 · 🧺 LA CASSETTA — la cosa da FARE
   Sei posti da riempire con i vasetti della collezione. Nel carrello
   finiscono come vasetti singoli: il magazzino scala giusto.
   ═════════════════════════════════════════════════════════════════ */
const cassetta = {
  vasetti: [],
  posti: [null, null, null, null, null, null],
  trova(id) { return this.vasetti.find((v) => v.id === id); },
  metti(id) {
    const libero = this.posti.indexOf(null);
    if (libero === -1) return;
    this.posti[libero] = id;
    this.rendi();
  },
  togli(i) { this.posti[i] = null; this.rendi(); },
  get pieni() { return this.posti.filter(Boolean).length; },

  rendi() {
    const cont = document.querySelector('#cassetta-posti');
    if (!cont) return;
    cont.innerHTML = '';
    this.posti.forEach((id, i) => {
      const posto = document.createElement('div');
      posto.className = 'posto';
      posto.dataset.pieno = id ? '1' : '0';
      if (id) {
        const v = this.trova(id);
        posto.innerHTML = v && v.foto ? `<img src="${esc(v.foto)}" alt="${esc(v.nome)}" loading="lazy" decoding="async" width="200" height="200">` : '';
        const via = document.createElement('button');
        via.className = 'posto__via'; via.type = 'button';
        via.setAttribute('aria-label', 'Togli ' + (v ? v.nome : '') + ' dalla cassetta');
        via.textContent = '×';
        via.addEventListener('click', () => this.togli(i));
        posto.appendChild(via);
      } else {
        posto.innerHTML = `<span class="posto__n" aria-hidden="true">${i + 1}</span>`;
      }
      cont.appendChild(posto);
    });

    const conto = document.querySelector('#cassetta-conto');
    if (conto) {
      const spesa = this.posti.filter(Boolean).reduce((s, id) => s + ((this.trova(id) || {}).prezzo || 0), 0);
      conto.textContent = this.pieni === 0
        ? 'Sei posti liberi'
        : this.pieni + (this.pieni === 1 ? ' vasetto scelto' : ' vasetti scelti') + ' su 6 · ' + euro(spesa);
    }
    const btn = document.querySelector('#cassetta-ordina');
    if (btn) btn.disabled = this.pieni === 0;
    document.querySelectorAll('.cassetta__scelta').forEach((b) => {
      b.disabled = this.pieni >= 6 || b.hasAttribute('data-esaurita');
    });
  },

  ordina(btn) {
    if (!this.pieni) return;
    const conta = {};
    this.posti.filter(Boolean).forEach((id) => { conta[id] = (conta[id] || 0) + 1; });
    carrello.aggiungi(Object.entries(conta).map(([id, q]) => ({ id: Number(id), quantity: q })), btn);
  },
};

function avviaCassetta() {
  const dati = document.querySelector('#cassetta-dati');
  const scelte = document.querySelector('#cassetta-scelte');
  if (!dati || !scelte) return;
  cassetta.vasetti = leggiJSON(dati) || [];
  cassetta.vasetti.forEach((v) => {
    const b = document.createElement('button');
    b.className = 'cassetta__scelta';
    b.type = 'button';
    if (!v.disponibile) b.setAttribute('data-esaurita', '');
    b.innerHTML = `${v.foto ? `<img src="${esc(v.foto)}" alt="" loading="lazy" decoding="async" width="104" height="104">` : ''}
      <span><b>${esc(v.nome)}</b><span>${esc(v.formato)} · ${v.disponibile ? euro(v.prezzo) : 'esaurito'}</span></span>`;
    b.addEventListener('click', () => cassetta.metti(v.id));
    scelte.appendChild(b);
  });
  const btn = document.querySelector('#cassetta-ordina');
  if (btn) btn.addEventListener('click', () => cassetta.ordina(btn));
  cassetta.rendi();
}

/* ═════════════════════════════════════════════════════════════════
   6 · IL CARRELLO — quello vero di Shopify, nel cassetto della landing
   Ogni riga è una variante. Le quantità si cambiano da qui; la cassa è
   quella di Shopify, con pagamento a carta.
   ═════════════════════════════════════════════════════════════════ */
/* la nota del cassetto la scrive il Liquid (snippets/lume-spedizione-costi): qui la si ricorda per ripristinarla */
const NOTA_CARRELLO = ((document.querySelector('#carrello-nota') || {}).textContent || '').trim();

const carrello = {
  stato: null,

  async chiedi(url, corpo) {
    const r = await fetch(url, corpo
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo) }
      : { headers: { Accept: 'application/json' } });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.description || d.message || 'Il carrello non si è aggiornato. Riprova.');
    return d;
  },
  async carica() {
    try { this.stato = await this.chiedi(CONFIG.rotte.cart + '.js'); this.rendi(); }
    catch (e) { /* il carrello resta com'è: la pagina funziona lo stesso */ }
  },
  async aggiungi(items, btn) {
    const testo = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Aggiungo…'; }
    try {
      await this.chiedi(CONFIG.rotte.add + '.js', { items });
      await this.carica();
      this.avvisa('');
    } catch (e) {
      await this.carica();
      this.avvisa(e.message);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = testo; }
      this.apri();
    }
  },
  async cambia(key, quantity) {
    try { this.stato = await this.chiedi(CONFIG.rotte.change + '.js', { id: key, quantity }); this.rendi(); this.avvisa(''); }
    catch (e) { this.avvisa(e.message); await this.carica(); }
  },
  avvisa(msg) {
    const n = document.querySelector('#carrello-nota');
    if (!n) return;
    if (msg) { n.textContent = msg; n.dataset.errore = '1'; }
    else { n.textContent = NOTA_CARRELLO; delete n.dataset.errore; }
  },

  apri() {
    const c = document.querySelector('#cassetto');
    if (!c) return;
    c.dataset.aperto = '1';
    document.querySelector('#velo').dataset.aperto = '1';
    c.querySelector('.cassetto__chiudi').focus();
  },
  chiudi() {
    const c = document.querySelector('#cassetto');
    if (!c) return;
    c.dataset.aperto = '0';
    document.querySelector('#velo').dataset.aperto = '0';
  },

  rendi() {
    const s = this.stato;
    const lista = document.querySelector('#carrello-lista');
    if (!s || !lista) return;
    const vuoto = document.querySelector('#carrello-vuoto');
    const conta = document.querySelector('#carrello-n');
    const cassa = document.querySelector('#alla-cassa');
    lista.innerHTML = '';
    vuoto.hidden = s.items.length > 0;
    cassa.disabled = s.items.length === 0;

    s.items.forEach((it) => {
      const formato = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      const li = document.createElement('li');
      li.className = 'riga';
      li.innerHTML = `
        ${it.image ? `<img class="riga__foto" src="${esc(foto(it.image, 120))}" alt="" width="56" height="56" loading="lazy">` : ''}
        <div class="riga__testo">
          <b>${esc(it.product_title)}</b>
          <span>${esc(formato)}</span>
        </div>
        <div class="riga__quanti">
          <button class="riga__meno" type="button" aria-label="Uno in meno">−</button>
          <span class="riga__n" aria-live="polite">${it.quantity}</span>
          <button class="riga__piu" type="button" aria-label="Uno in più">+</button>
        </div>
        <b class="riga__prezzo">${euro(it.final_line_price)}</b>`;
      li.querySelector('.riga__meno').addEventListener('click', () => this.cambia(it.key, it.quantity - 1));
      li.querySelector('.riga__piu').addEventListener('click', () => this.cambia(it.key, it.quantity + 1));
      const via = document.createElement('button');
      via.className = 'cassetto__via'; via.type = 'button'; via.textContent = 'togli';
      via.setAttribute('aria-label', `Togli ${it.product_title} ${formato} dal carrello`);
      via.addEventListener('click', () => this.cambia(it.key, 0));
      li.appendChild(via);
      lista.appendChild(li);
    });

    document.querySelector('#carrello-totale').textContent = s.items.length ? 'Totale ' + euro(s.total_price) : '';
    conta.textContent = s.item_count;
    conta.hidden = s.item_count === 0;
  },
};

/* ═════════════════════════════════════════════════════════════════
   7 · SCRIVERE ALL'AZIENDA — WhatsApp, solo per le richieste particolari
   ═════════════════════════════════════════════════════════════════ */
function scriviCi(testo) {
  if (!CONFIG.whatsapp) return;
  window.open(`https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(testo)}`, '_blank', 'noopener');
}

/* ═════════════════════════════════════════════════════════════════
   7b · IL TRACCIAMENTO
   Non abbiamo un server: il numero di spedizione va aperto sul sito del
   corriere. I tre indirizzi qui sotto sono stati PROVATI uno per uno —
   GLS e Poste precompilano il campo, BRT esegue direttamente la ricerca.
   Se un corriere cambia indirizzo, si cambia qui e basta.
   ═════════════════════════════════════════════════════════════════ */
const CORRIERI = {
  gls: {
    nome: 'GLS',
    url: (n) => 'https://gls-group.com/IT/it/servizi-online/ricerca-spedizioni?match=' + encodeURIComponent(n),
    nudo: 'https://gls-group.com/IT/it/servizi-online/ricerca-spedizioni',
    aiuto: 'Il numero di spedizione GLS, come lo trovi sull\'email di partenza.',
    cifre: null,
  },
  brt: {
    nome: 'BRT — Bartolini',
    url: (n) => 'https://vas.brt.it/vas/sped_det_show.hsm?referer=sped_numspe_par.htm&Nspediz=' + encodeURIComponent(n),
    nudo: 'https://vas.brt.it/vas/sped_numspe_par.htm',
    aiuto: 'BRT vuole il numero di spedizione da 12 cifre.',
    cifre: 12,
  },
  sda: {
    nome: 'SDA',
    url: (n) => 'https://www.poste.it/cerca/index.html#/risultati-spedizioni/' + encodeURIComponent(n),
    nudo: 'https://www.poste.it/cerca/index.html#/',
    aiuto: 'SDA fa parte di Poste Italiane: la ricerca si apre su poste.it.',
    cifre: null,
  },
};

function avviaTracciamento() {
  const form = document.querySelector('#traccia');
  if (!form) return;

  const scelta = form.querySelector('#traccia-corriere');
  const campo  = form.querySelector('#traccia-numero');
  const aiuto  = form.querySelector('#traccia-aiuto');
  const esito  = form.querySelector('#traccia-esito');
  const vai    = form.querySelector('#traccia-nudo');

  const pulisci = (n) => n.replace(/[\s.\-]/g, '');

  function aggiorna() {
    const c = CORRIERI[scelta.value];
    aiuto.textContent = c.aiuto;
    vai.href = c.nudo;
    vai.textContent = 'Apri il sito ' + c.nome;
    esito.textContent = '';
    esito.dataset.stato = '';
  }
  scelta.addEventListener('change', aggiorna);
  aggiorna();

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const c = CORRIERI[scelta.value];
    const n = pulisci(campo.value);

    if (!n) {
      esito.dataset.stato = 'no';
      esito.textContent = 'Scrivi il numero di spedizione.';
      campo.focus();
      return;
    }
    if (!/^[A-Za-z0-9]+$/.test(n)) {
      esito.dataset.stato = 'no';
      esito.textContent = 'Il numero contiene caratteri che non vanno: ricopialo dall\'email.';
      campo.focus();
      return;
    }
    if (c.cifre && n.length !== c.cifre) {
      esito.dataset.stato = 'no';
      esito.textContent = `${c.nome} vuole ${c.cifre} cifre, questo ne ha ${n.length}. Controlla il numero.`;
      campo.focus();
      return;
    }

    esito.dataset.stato = 'si';
    esito.textContent = 'Apro la pagina di ' + c.nome + ' in una scheda nuova…';
    open(c.url(n), '_blank', 'noopener');
  });
}

/* 8 · I VIDEO PIGRI — nessun byte scaricato finché non servono, e quando
   escono dallo schermo si fermano: la pagina resta leggera e il portatile
   non si mette a soffiare. */
function avviaVideoPigri() {
  const video = [...document.querySelectorAll('video[data-pigro]')];
  if (!video.length) return;

  const accendi = (v) => {
    if (v.dataset.acceso) return;
    v.dataset.acceso = '1';
    v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
    v.load();
    v.play().catch(() => {});      // se il browser rifiuta l'autoplay resta il poster
  };

  if (!('IntersectionObserver' in window)) { video.forEach(accendi); return; }

  const occhio = new IntersectionObserver((voci) => {
    voci.forEach((v) => {
      if (v.isIntersecting) { accendi(v.target); v.target.play().catch(() => {}); }
      else if (v.target.dataset.acceso) v.target.pause();
    });
  }, { rootMargin: '200px 0px' });

  video.forEach((v) => occhio.observe(v));
}

/* ═════════════════════════════════════════════════════════════════
   9 · IL MENU DEL TELEFONO
   ═════════════════════════════════════════════════════════════════ */
function avviaMenu() {
  const testa = document.querySelector('#testa');
  const btn = document.querySelector('#menu-btn');
  if (!testa || !btn) return;

  function chiudi() { testa.dataset.menu = '0'; btn.setAttribute('aria-expanded', 'false'); }

  btn.addEventListener('click', () => {
    const aperto = testa.dataset.menu === '1';
    testa.dataset.menu = aperto ? '0' : '1';
    btn.setAttribute('aria-expanded', String(!aperto));
  });
  testa.querySelectorAll('nav a').forEach((a) => a.addEventListener('click', chiudi));
  addEventListener('keydown', (e) => { if (e.key === 'Escape') chiudi(); });
}

/* ═════════════════════════════════════════════════════════════════
   11 · SALVA LA RICETTA
   Il cliente ha chiesto la ricetta scaricabile ACCANTO al prodotto.
   Qui ogni ricetta ha il suo pulsante e stampa (o salva in PDF) SOLO
   quella, non tutte e tre insieme.
   ═════════════════════════════════════════════════════════════════ */
function avviaStampa() {
  const bottoni = document.querySelectorAll('[data-stampa]');
  if (!bottoni.length) return;

  function pulisci() { delete document.body.dataset.sola; }
  addEventListener('afterprint', pulisci);

  bottoni.forEach((b) => {
    b.addEventListener('click', () => {
      document.body.dataset.sola = b.dataset.stampa;
      /* setTimeout e non requestAnimationFrame: rAF non scatta se la scheda
         non è in primo piano, e il flag resterebbe appiccicato al body —
         la stampa successiva mostrerebbe una ricetta sola. */
      setTimeout(() => {
        try { print(); } finally { setTimeout(pulisci, 600); }
      }, 60);
    });
  });
}

/* ═════════════════════════════════════════════════════════════════
   12 · IL BANNER COOKIE — una riga sola
   Il sito non installa cookie di profilazione: niente analytics di terzi,
   niente script esterni. Questo è solo l'avviso.
   ═════════════════════════════════════════════════════════════════ */
function avviaCookie() {
  const b = document.querySelector('#cookie');
  if (!b) return;
  let visto = null;
  try { visto = localStorage.getItem('lume-cookie'); } catch (e) { /* niente storage: pazienza */ }
  if (visto) return;
  b.hidden = false;
  b.querySelector('button').addEventListener('click', () => {
    b.hidden = true;
    try { localStorage.setItem('lume-cookie', '1'); } catch (e) { /* idem */ }
  });
}

/* ═════════════════════════════════════════════════════════════════
   AVVIO
   ═════════════════════════════════════════════════════════════════ */
function avvia() {
  const rendiScia = avviaScia();
  avviaComparse();

  /* Le scene sono isolate: se una non parte, il negozio funziona lo stesso —
     un effetto grafico non deve mai poter spegnere il carrello. */
  [scenaApertura, scenaTempo, scenaStagioni, scenaSpedizione, scenaParallasse, scenaNumeri]
    .forEach((scena) => {
      try { scena(); }
      catch (e) { console.warn('scena non avviata:', scena.name, e); }
    });

  avviaScorrimento(rendiScia);
  document.querySelectorAll('[data-scheda], [data-pagina-prodotto]').forEach(collegaVarianti);
  avviaCassetta();
  avviaTracciamento();
  avviaMenu();
  avviaVideoPigri();
  avviaStampa();
  avviaCookie();

  const cassetto = document.querySelector('#cassetto');
  if (cassetto) {
    carrello.carica();
    const apri = document.querySelector('#apri-carrello');
    if (apri) apri.addEventListener('click', (e) => { e.preventDefault(); carrello.apri(); });
    cassetto.querySelector('.cassetto__chiudi').addEventListener('click', () => carrello.chiudi());
    document.querySelector('#velo').addEventListener('click', () => carrello.chiudi());
    addEventListener('keydown', (e) => { if (e.key === 'Escape') carrello.chiudi(); });
  }

  document.querySelectorAll('[data-scrivi]').forEach((el) => {
    el.addEventListener('click', (e) => { e.preventDefault(); scriviCi(el.dataset.scrivi); });
  });
}

if (document.readyState === 'loading') addEventListener('DOMContentLoaded', avvia);
else avvia();
